<signature-pad
  id="signaturePad"
  #signaturePad
  [options]="signaturePadOptions"
  (drawStart)="drawBegin()"
  (drawEnd)="drawComplete()"
  style="padding-bottom: 6px"
>
</signature-pad>
